import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import history from './components/History';
import {Auth0Provider} from "./auth/sso";
import {NavBarProvider} from "./components/NavBar";
import {SnackbarProvider} from "./components/Snackbar";

const onRedirectCallback = appState => {
    history.push(
        appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
    );
};

const ssoDomain = `${process.env.REACT_APP_SSO_DOMAIN}`;
const ssoClientId = `${process.env.REACT_APP_SSO_CLIENT_ID}`;

ReactDOM.render(
    <Auth0Provider
        domain={ssoDomain}
        client_id={ssoClientId}
        redirect_uri={window.location.origin}
        audience={"iot-ragnarok"}
        onRedirectCallback={onRedirectCallback}
    >
        <NavBarProvider>
            <SnackbarProvider>
                <App/>
            </SnackbarProvider>
        </NavBarProvider>
    </Auth0Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();